'use client';

import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { type PartnerDisplay } from '@/modules/partners/types';

type Props = {
  questions: PartnerDisplay['questions'];
  name: string;
};

export function Questions({ questions, name }: Props) {
  const t = useTranslations('partners');

  if (!questions) {
    return null;
  }

  return (
    // eslint-disable-next-line no-restricted-syntax
    <section className={styles.pinkBackground} data-testid="questions-section">
      <div className={styles.section}>
        <Heading
          variant="lg"
          className={styles.sectionTitle}
          // eslint-disable-next-line no-restricted-syntax
          data-testid="questions-title"
        >
          {t(`Partners.${name}.QuestionsTitle`)}
        </Heading>
        <div className={styles.questionsContainer}>
          {Array.from(Array(questions.numberOfQuestions)).map((_, index) => {
            const count = index + 1;
            return (
              <div className={styles.questionContainer} key={index}>
                {/* eslint-disable-next-line no-restricted-syntax */}
                <Heading variant="md" data-testid={`question-title-${index}`}>
                  {t(`Partners.${name}.QuestionsSubTitle${count}`)}
                </Heading>
                <Body
                  variant="sm-regular"
                  // eslint-disable-next-line no-restricted-syntax
                  data-testid={`question-answer-${index}`}
                >
                  {t(`Partners.${name}.QuestionsAnswer${count}`)}
                </Body>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
